/**
 * Owner-read subscriptions for ClinicalHUD3 Live grant and attestation docs.
 */
import { db } from "services/firebase";
import {
  CLINICAL_HUD3_LIVE_ACCESS_COLLECTION,
  CLINICAL_HUD3_LIVE_ATTESTATION_COLLECTION,
} from "./clinicalHud3Constants";

export function subscribeToClinicalHud3LiveAccess(uid, onData) {
  if (!uid) {
    onData(null);
    return () => {};
  }
  return db
    .collection(CLINICAL_HUD3_LIVE_ACCESS_COLLECTION)
    .doc(uid)
    .onSnapshot(
      (snap) => {
        onData(snap.exists ? snap.data() : null);
      },
      (err) => {
        console.warn("[clinicalHud3LiveAccess] subscription failed", err);
        onData(null);
      },
    );
}

export function subscribeToClinicalHud3LiveAttestation(uid, onData) {
  if (!uid) {
    onData(null);
    return () => {};
  }
  return db
    .collection(CLINICAL_HUD3_LIVE_ATTESTATION_COLLECTION)
    .doc(uid)
    .onSnapshot(
      (snap) => {
        onData(snap.exists ? snap.data() : null);
      },
      (err) => {
        console.warn("[clinicalHud3LiveAttestation] subscription failed", err);
        onData(null);
      },
    );
}
